var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-card-actions',{attrs:{"align":"center"}},[_c('q-btn',{staticClass:"btn-brand",attrs:{"no-caps":""},on:{"click":_vm.onHistoricData}},[_vm._v("Historic Data")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }